<template>
  <div>
    <configurar-associacao-fila-tipo-solicitacao-dialog
      v-if="associacaoSelecionada"
      :is-configurar-associacao-fila-tipo-solicitacao-dialog-open.sync="isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen"
      :associacao-data="associacaoSelecionada"
      :fila-id="filaId"
      @refetch-data="$emit('refetch-data')"
    />

    <ativar-ou-inativar-associacao-dialog
      :is-ativar-ou-inativar-associacao-dialog-open.sync="isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen"
      :is-associacao-ativa-mensagem="isAssociacaoAtivaMensagem"
      :loading="loading"
      :close-dialog="closeDialog"
      :confirmar-ativacao-ou-inativacao-da-associacao="confirmarAtivacaoOuInativacaoDaAssociacao"
    />

    <v-data-table
      item-key="tipoSolicitacaoId"
      no-data-text="Sem dados"
      :headers="headers"
      :items="items"
      :item-class="cursorPointer"
      :footer-props="{
        'items-per-page-text':'Linhas por página',
        'page-text': '{0}-{1} de {2}',
        'items-per-page-all-text': 'Todos',
      }"
      @click:row="selectAssociacao"
    >
      <template #[`item.nome`]="{ item }">
        <div class="d-flex align-center">
          <v-avatar
            :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
            size="32"
          >
            <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
              {{ item.tipoSolicitacaoNome.toUpperCase().charAt(0) }}{{ item.tipoSolicitacaoNome.toUpperCase().charAt(1) }}
            </span>
          </v-avatar>
          <div class="d-flex flex-column ms-3">
            {{ item.tipoSolicitacaoNome }}
          </div>
        </div>
      </template>

      <template #[`item.status`]="{ item }">
        <v-chip
          class="v-chip-light-bg font-weight-semibold text-capitalize"
          small
          :class="`${item.ativo ? 'success--text' : 'secondary--text'}`"
          :color="`${item.ativo ? 'success' : 'secondary'}`"
        >
          {{ item.ativo ? 'Ativo' : 'Inativo' }}
        </v-chip>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              class="ml-n5"
              color="primary"
              v-on="on"
            >
              <v-icon @click="ativarOuInativarAssociacaoItem(item)">
                {{ icons.mdiDotsVertical }}
              </v-icon>
            </v-btn>
          </template>

          <v-list v-if="acessoDisable">
            <v-list-item v-if="item.ativo">
              <v-list-item-title
                role="button"
                class="d-flex align-end"
                @click="selectAssociacao(item)"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ icons.mdiPencilOutline }}
                </v-icon>
                <span class="text-capitalize"> editar </span>
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title
                role="button"
                class="d-flex align-end"
                @click="openAssociarOuDesassociar"
              >
                <v-icon
                  size="20"
                  class="mr-1"
                >
                  {{ item.ativo ? icons.mdiCloseThick : icons.mdiCheckBold }}
                </v-icon>
                <span class="text-capitalize"> {{ isAssociacaoAtivaMensagem }} </span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  mdiCloseThick, mdiDotsVertical, mdiCheckBold, mdiPencilOutline,
} from '@mdi/js'
import { onMounted, ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import AtivarOuInativarAssociacaoDialog from '@/views/ativar-ou-inativar-associacao-dialog/AtivarOuInativarAssociacaoDialog.vue'
import ConfigurarAssociacaoFilaTipoSolicitacaoDialog from './ConfigurarAssociacaoFilaTipoSolicitacaoDialog.vue'
import FuncionalidadesEnum from '@/models/entities/funcionalidade/FuncionalidadesEnum'
import FilaService from '@/services/modules/FilaService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    ConfigurarAssociacaoFilaTipoSolicitacaoDialog,
    AtivarOuInativarAssociacaoDialog,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    acessoDisable: {
      type: Boolean,
      default: true,
    },
    filaId: {
      type: Number,
      required: true,
    },
  },

  setup(props, { emit }) {
    const { funcionalidades } = storeToRefs(useAuthStore())
    const possuiAcessoAoUpdateDaAssociacao = ref(false)

    onMounted(() => {
      possuiAcessoAoUpdateDaAssociacao.value = funcionalidades.value.includes(FuncionalidadesEnum.UpdateFilaTipoSolicitacaoId)
    })

    const isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen = ref(false)

    const loading = ref(false)
    const tipoSolicitacaoId = ref(0)
    const isAssociacaoAtiva = ref(undefined)
    const isAssociacaoAtivaMensagem = ref('')

    function ativarOuInativarAssociacaoItem(item) {
      tipoSolicitacaoId.value = item.tipoSolicitacaoId
      isAssociacaoAtiva.value = item.ativo
      isAssociacaoAtivaMensagem.value = item.ativo ? 'inativar' : 'ativar'
    }
    function openAssociarOuDesassociar() {
      isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen.value = true
    }
    function closeDialog() {
      isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen.value = false
    }
    async function confirmarAtivacaoOuInativacaoDaAssociacao() {
      if (loading.value) return
      try {
        loading.value = true
        await FilaService.ativarOuInativarAssociacaoEntreFilaETipoDeSolicitacao(props.filaId, tipoSolicitacaoId.value, { ativar: !isAssociacaoAtiva.value })
        emit('refetch-data')
      } finally {
        closeDialog()
        loading.value = false
      }
    }

    const isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen = ref(false)
    const associacaoSelecionada = ref(null)

    function selectAssociacao(item) {
      if (!item.ativo) return
      associacaoSelecionada.value = item
      isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen.value = true
    }

    const headers = [
      { text: 'NOME', value: 'nome' },
      { text: 'STATUS', value: 'status' },
      {
        text: 'OPÇÔES',
        value: 'actions',
        align: 'center',
      },
    ]

    return {
      possuiAcessoAoUpdateDaAssociacao,
      isAtivarOuInativarAssociacaoFilaTipoSolicitacaoDialogOpen,
      loading,
      isAssociacaoAtiva,
      isAssociacaoAtivaMensagem,
      ativarOuInativarAssociacaoItem,
      openAssociarOuDesassociar,
      closeDialog,
      confirmarAtivacaoOuInativacaoDaAssociacao,
      isConfigurarAssociacaoFilaTipoSolicitacaoDialogOpen,
      associacaoSelecionada,
      selectAssociacao,
      icons: {
        mdiCloseThick,
        mdiDotsVertical,
        mdiCheckBold,
        mdiPencilOutline,
      },
      headers,
      cursorPointer: item => (item.ativo && possuiAcessoAoUpdateDaAssociacao.value ? 'cursor-pointer' : ''),
    }
  },
}
</script>
